/**
 * UI-24 (Pegah): "Why different height and width for the two tabs? We should
 * make it consistent not only here but also maintain *same* window size in
 * other screens, for example 'Add' button in boards … Consistency in UI is a
 * major issue *throughout*."
 *
 * Dialogs were each inventing a width — a survey at the time of this change
 * found NINE distinct values across the app (425, 448, 480, 560, 576, 640,
 * 680, 720, 800, 1024, 1152px), most of them a few pixels from a neighbour and
 * none of them referring to each other. That is the "throughout" she means:
 * not one wrong number, but no shared answer to "how wide is a dialog".
 *
 * Three sizes, chosen to match widths already in use so adopting one is not a
 * silent resize:
 *
 *   sm  a short form or a confirmation — a few fields, no list
 *   md  a form with a list or a small table inside it
 *   lg  a browser: a full table the user reads and scans
 *
 * Reach for the nearest size rather than adding a fourth. A dialog that truly
 * needs its own width is a design decision and should say so in a comment.
 */
export const DIALOG_WIDTH = {
  sm: 'sm:max-w-[480px]',
  md: 'sm:max-w-[640px]',
  lg: 'sm:max-w-[1152px]',
} as const

export type DialogWidth = keyof typeof DIALOG_WIDTH
